import { render, staticRenderFns } from "./employment-detail.vue?vue&type=template&id=70f1f254"
import script from "./employment-detail.vue?vue&type=script&lang=js"
export * from "./employment-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports